import ExtendableError from './ExtendableError.js';
/** If an abstract method is not overridden, an AbstractMethodError will be thrown */
export default class AbstractMethodError extends ExtendableError {
    /** Constructs an Abstract Method Error
        @param message The message to display
        @param node Optional node that triggered the error
    */
    constructor(message, node) {
        super(message);
        console.error(message, node);
    }
}
